import { createBlock } from 'factories/block';
import { Block } from 'factories/block';
import { InteractionProps, reverse } from './interaction';
import { createLayout } from 'factories/layout';
import { createMediaBlock } from './media';
import { createContinueBtn } from './continueBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';
import { getPlaceholderText } from './text';

export type ImageInteractionProps = InteractionProps & {};

const createAssessmentIntroduction = (props?: {}) => {
  return createBlock(
    'AssessmentIntroduction',
    [
      createMediaBlock({}),
      createBlock('Text', [], {
        props: {
          content: getPlaceholderText('h2', 'heading-two'),
          className: 'text-align-center',
        },
      }),
    ],
    { props: {} }
  );
};

export const createAssessmentIntroductionInteractionBlock = (
  props: any,
  offset: number = 0
) => {
  return createBlock(
    'Interaction',
    [
      createAssessmentIntroduction(),

      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(props.style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'AssessmentIntroduction',
        name: props.name,
        sId: getSId('interaction', offset),
        style: props.style || {},
      },
      meta: {
        subType: 'AssessmentIntroduction',
      },
    }
  );
};

export const interactionConfig = {};
